import Vue from 'vue';
import gaService from './ga.service';

const sportIcons = {
  2: 'fa-table-tennis',
  3: 'fa-futbol',
  4: 'fa-volleyball-ball',
  5: 'fa-basketball-ball',
  6: 'fa-volleyball-ball',
  9: 'fa-hockey-puck',
  10: 'fa-volleyball-ball',
  13: 'fa-volleyball-ball',
  17: 'fa-chess-pawn',
  20: 'fa-football-ball',
  21: 'fa-football-ball',
  28: 'fa-futbol',
  33: 'fa-football-ball'
};

export default {
  async openSession() {
    gaService.send('games', 'bk', 'bk');
    return (await Vue.http.post('/api/bk/session/open', { })).data;
  },
  async closeSession() {
    return (await Vue.http.post('/api/bk/session/close')).data;
  },
  async getBkBet(bkBetId) {
    return (await Vue.http.get(`/api/bk/bets/${bkBetId}`)).data;
  },
  async getBkBets(balanceId, date, take, skip, isSettled) {
    return (await Vue.http.post('/api/bk/bets', { balanceId, date, take, skip, isSettled })).data;
  },
  sportIcons: sportIcons
}



// WEBPACK FOOTER //
// ./_common/services/bk.service.js